import { Action } from 'redux';

import {
  ResultPreviewAction,
  ResultPreviewActionConstants,
  ResultPreviewState,
  SetResultPreviewArgs,
  SetAttachPreviewArgs,
} from './types';

export const initialState: ResultPreviewState = {
  networkStates: {
    resultPreviewRequest: {
      isRequesting: false,
    },
    attachPreviewRequest: {
      isRequesting: false,
    },
  },
  isPreviewInitialized: false,
};

export default function resultPreviewReducer(
  state = initialState,
  action: Action<ResultPreviewActionConstants>,
): ResultPreviewState {
  switch (action.type) {
    case ResultPreviewActionConstants.INITIALIZE: {
      return {
        ...state,
        isPreviewInitialized: true,
      };
    }
    case ResultPreviewActionConstants.RESULT_PREVIEW_REQUEST: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          resultPreviewRequest: {
            ...state.networkStates.resultPreviewRequest,
            isRequesting: true,
          },
        },
      };
    }
    case ResultPreviewActionConstants.RESULT_PREVIEW_SET: {
      const act = (action as ResultPreviewAction<SetResultPreviewArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          resultPreviewRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        loadedStatus: act.result,
      };
    }
    case ResultPreviewActionConstants.ATTACH_PREVIEW_REQUEST: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          attachPreviewRequest: {
            ...state.networkStates.attachPreviewRequest,
            isRequesting: true,
          },
        },
      };
    }
    case ResultPreviewActionConstants.ATTACH_PREVIEW_SET: {
      const act = (action as ResultPreviewAction<SetAttachPreviewArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          attachPreviewRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
      };
    }
    default:
      return state;
  }
}
